import { render, staticRenderFns } from "./ScheduledNotifications.vue?vue&type=template&id=6797919b&scoped=true"
import script from "./ScheduledNotifications.vue?vue&type=script&lang=js"
export * from "./ScheduledNotifications.vue?vue&type=script&lang=js"
import style0 from "./ScheduledNotifications.vue?vue&type=style&index=0&id=6797919b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6797919b",
  null
  
)

export default component.exports